import Button from "./Button";
import React, { useState } from "react";
import { useReducer } from "react";
import { reducer,initialState } from "../reducers/reducers";
import '../App.css'; // Optional: If you're using an external CSS file
import EditText from "./EditText";
import API_URLS from "../Urls";
const AddObjectType = ({tipo,onAccept, onCancel}) => {
    const [type, setType] = useState()
    const [state, dispatch] = useReducer(reducer, initialState);
    const postData = (url, dataToSend, onSuccesful) => {
        console.log("Posting to URL:", url); // Check URL during each post
        console.log("Data to send:", dataToSend);

        fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(dataToSend)
        })
        .then(response => {
            if (!response.ok) throw new Error('Network response was not ok ' + response.statusText);
            return response.json();
        })
        .then(data => {
            if (typeof onSuccesful === 'function') onSuccesful(data);
            console.log(data);
        })
        .catch(error => 
            alert(error)
        );
    };
    return(
        <div className="modal-overlay">
        <div className="confirm-modal">
            <EditText text='Escribe el tipo de objeto' onChange={data=>setType(data)}></EditText>
            <div className="invisible-horizontal-container">
                <Button text="Agregar tipo" onClick={()=>{
                    if(!type || type == ''){
                        alert("Asegurese de introducir el nombre del tipo")
                    } else {
                        postData(API_URLS.OBJECTTYPES, {objecttype:tipo, tipo:type},()=>{onAccept()})
                    }
                }} color="#DF7476"></Button>
                <Button text="Cancelar" onClick={()=>onCancel()} color="#000000"></Button>
            </div>
        </div>
        </div>
    )
}
export default AddObjectType;